module.exports = __webpack_public_path__ + "media/music/synth_chords_8-f0ac74f9.mp3";